<template>
  <div class="boards">
    <div class="page-info">
      <div>
        <div class="page-title-container">
          
          
          <!-- <div class="buttons">

            <b-button tag="router-link" to="/admin/blog" class="is-primary">
            Blog
            </b-button>

          </div> -->
        </div>
      </div>
    </div>
    
    <div id="users" v-if="models">
      <h1 class="title">
          100 most recent projects
      </h1>
      <br>
      Total users: {{ this.users.length }}
      Total projects: {{ this.models.length }}
      <!-- <b-table
            :data="data_users"
            :columns="columns_users"
            :default-sort="['createdAt','desc']"
            sort-multiple>
     </b-table> -->
      <br><br>
      <br>
      <h1 class="subtitle">
          Projects
      </h1>
      <br>
      <b-table detailed :data="models" >
          <b-table-column  field="userId" label="User / Company" v-slot="props">
            <a :href="'/projects/'+props.row.id">
              {{ users.filter(u => u.id == props.row.userId)[0].email }} / {{ users.filter(u => u.id == props.row.userId)[0].infoProfile.company }}
            </a>
          </b-table-column>
          <b-table-column field="name" label="Project name" v-slot="props">
            <a :href="'/projects/'+props.row.id">
              {{ props.row.name }}
            </a>
          </b-table-column>
          <b-table-column field="created_at" label="created_at" v-slot="props">
            <a :href="'/projects/'+props.row.id">
              {{ props.row.createdAt.toDate().toDateString() }}
            </a>
          </b-table-column>

          <b-table-column field="processing_status" label="status" v-slot="props">
            <a :href="'/projects/'+props.row.id">
              {{ props.row.processing_status }}
              <span v-if="props.row.processing_error_log">
                / Error
              </span>
            </a>
          </b-table-column>
          <b-table-column width="100%" field="datasets" label="datasets" v-slot="props">
            <a :href="'/projects/'+props.row.id">
              {{ users.filter(u => u.id == props.row.userId)[0].datasetRowsTotal }}
            </a>
          </b-table-column>
          <b-table-column width="100%" field="models" label="models" v-slot="props">
            <a :href="'/projects/'+props.row.id">
              {{ users.filter(u => u.id == props.row.userId)[0].modelTrainingsTotal }}
            </a>
          </b-table-column>
          <b-table-column width="100%" field="predictions" label="predictions" v-slot="props">
            <a :href="'/projects/'+props.row.id">
              {{ users.filter(u => u.id == props.row.userId)[0].predictionsTotal }}
            </a>
          </b-table-column>
          <template #detail="props">
                <article class="media">
                    <div class="media-content">
                        <div class="content">
                          <h3 v-if="props.row.processing_error_log">Error</h3>
                          <p>{{ props.row.processing_error_log }}</p>
                        </div>
                        <div class="content">
                          <h3>Profile</h3>
                            {{ users.filter(u => u.id == props.row.userId)[0].infoProfile }}
                        </div>
                        <div class="content">
                          <h3>Geral</h3>
                            {{ users.filter(u => u.id == props.row.userId)[0] }}
                        </div>
                    </div>
                </article>
            </template>
      </b-table>

<!--       
      <router-link class="card board" :to="`/models/${model.id}/datasets`" 
          v-for="(model) in models"
          :key="model.id">
          
            {{ model.name }}
          - 
            {{ model.userId }}
          -
            {{ model.training_status }}
          - 
            {{ model.datasets }}
          <br>
      </router-link> -->
      
      <!-- <b-table
            :data="data_models"
            :columns="columns_models"
            sort-multiple>
     </b-table> -->
      <!-- <br>
      <h1 class="subtitle">
          Datasets
      </h1>
      <router-link class="card board" :to="`/datasets/${dataset.id}/analysis`" 
          v-for="(dataset) in datasets"
          :key="dataset.id">
          
            {{ dataset.name }}
          - 
            {{ dataset.userId }}
          -
            {{ dataset.instances }}
            
          <br>
      </router-link> -->
      <br>

    </div>
    <br>
  </div>
</template>

<script>
import 'vue-stepper-component'

export default {
  name: "Explore",
  data() {
    return {
      data_users: [],
      data_models: [],
      data_datasets: [],
      columns_users: [
          
            {
                field: 'email',
                label: 'email',
            },
            {
                field: 'createdAt',
                label: 'createdAt',
            },
            {
                field: 'models',
                label: 'models',
            },
            {
                field: 'datasets',
                label: 'datasets',
            },
            {
                field: 'status',
                label: 'status',
            },
      ],

          columns_projects: [
            {
                field: 'userId',
                label: 'userId',
            }
          ],
        columns_datasets: [
          {
                field: 'datasetId',
                label: 'datasetId',
          },
          {
                field: 'user',
                label: 'user',
          },
          {
              field: 'name',
              label: 'name',
          },
          {
              field: 'status',
              label: 'status',
          },
          {
              field: 'instances',
              label: 'instances',
          },
          {
              field: 'labeling',
              label: 'labeling',
          },
        ]
    };
  },
  components: {
  },
  computed: {
    users() {
      return this.$store.state.users;
    },
    models() {
      return this.$store.state.modelsAdmin;
    },
    datasets() {
        return this.$store.state.datasetsAdmin;
    }
  },
  methods:{
    build_data(){
      let users = this.users
        
        for(let i=0; i< users.length; i++){
          
          // let n_models = this.models.reduce((a,v) => (v.userId == user.id ? a+1:a), 0)
          // let n_datasets = this.datasets.reduce((a,v) => (v.userId == user.id ? a+1:a), 0)
          let n_models = this.models.filter((v) => (v.userId == users[i].id))
          let n_datasets = this.datasets.filter((v) => (v.userId == users[i].id))

          let row = {
            userId: users[i].id,
            createdAt: users[i].createdAt,//.split(" ").slice(0,3).join(" ").replace(",", ""), 
            //createdAt: Date.parse(users[i].createdAt).getTime(),
            email: users[i].email,
            models: 'Total '+ n_models.length,
            datasets: 'Total '+n_datasets.length
          }
          this.data_users.push(row)
        }
          for(let m=0; m < this.models.length; m++){
            let row = {
              modelId: this.models[m].id,
              user: users.filter((v) => (v.id == this.models[m].userId))[0].email,
              name: this.models[m].name,
              datasets: this.models[m].datasets,
              status: this.models[m].training_status
            }
            this.data_models.push(row)
          }

          for(let d=0; d < this.datasets.length; d++){
            let row = {
              datasetId: this.datasets[d].id,
              user: users.filter((v) => (v.id == this.datasets[d].userId))[0].email,
              name: this.datasets[d].name,
              status: this.datasets[d].is_analyzing,
              instances: this.datasets[d].instances,
              labeling: this.datasets[d].labeling,
            }
            this.data_datasets.push(row)
          }

      return 1
      }
  },
  created() {
    this.$store.dispatch("retrieveAllUsersAdmin");

    this.$store.dispatch("retrieveAllModelsAdmin");

    this.$store.dispatch("retrieveAllDatasetsAdmin");
    
    // if (this.users){
    //   this.build_data()
    // }
      
  },
};
</script>

<style lang="scss" scoped>
.boards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;

  .board {
    cursor: pointer;
    border: solid 1px #e6e4e4;
    border-radius: 4px;

    &:hover {
      background: #fafafa;
    }

    .info {
      padding: 16px;

      .name {
        display: block;
        margin-bottom: 8px;
        text-transform: capitalize;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .description {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        margin: 0;
        margin-bottom: 8px;
        overflow: hidden;
      }
    }
  }
}
</style>